import QuestionConfig from './QuestionConfig';

export default QuestionConfig;
